export const DISCORD_API_URL = process.env.REACT_APP_DISCORD_API_URL
export const SHARERING_API = process.env.REACT_APP_SHARERING_API
export const DISCORD_CLIENT_ID = process.env.REACT_APP_DISCORD_CLIENT_ID
export const DISCORD_AUTH_REDIRECT = process.env.REACT_APP_DISCORD_AUTH_REDIRECT
export const DISCORD_BACKEND_API_URL = process.env.REACT_APP_DISCORD_BACKEND_API_URL